export default "__VITE_ASSET__AclBSD7I__"